import { render, staticRenderFns } from "./MyAuthExamine.vue?vue&type=template&id=32320870&"
import script from "./MyAuthExamine.vue?vue&type=script&lang=js&"
export * from "./MyAuthExamine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports